function updateCachedFeatureLists(queryClient, updater) {
  queryClient.getQueriesData({ queryKey: ['featureToggles'] }).forEach(([queryKey, data]) => {
    if (!data) return
    const filter = queryKey[2]
    queryClient.setQueryData(queryKey, updater(data, filter))
  })
}

export function adjustTenantsCount(queryClient, featureName, delta) {
  updateCachedFeatureLists(queryClient, (features) =>
    features.map((item) =>
      item.name === featureName
        ? { ...item, tenantsCount: Math.max(0, (item.tenantsCount ?? 0) + delta) }
        : item,
    ),
  )
}

export function applyFeatureEdit(queryClient, { name, description, plans, usageType }) {
  updateCachedFeatureLists(queryClient, (features) =>
    features.map((item) => (item.name === name ? { ...item, description, plans, usageType } : item)),
  )
}

export function insertCreatedFeature(queryClient, { name, description, plans, usageType }) {
  updateCachedFeatureLists(queryClient, (features, filter) => {
    if (features.some((item) => item.name === name)) return features
    if (filter === 'PUBLIC' && usageType !== 'PUBLIC') return features
    return [...features, { name, description, plans, usageType, tenantsCount: 0 }]
  })
}
